import clsx from "clsx";

export default function CTASection({ onSave, onCancel, success }) {
  return (
    <div className="flex justify-around items-center mt-10">
      <div className={backBtn} onClick={onCancel}>
        Cancel & Go Back
      </div>
      <div className={saveBtn} onClick={onSave}>
        {success === 2 && "No New Changes"}
        {success === 1 && "Success !!"}
        {success === 0 && "Save Event"}
        {success === -1 && "Error"}
        {success === -2 && "Required Missing"}
      </div>
    </div>
  );
}

export const btnStyle = clsx(
  "py-3 px-6 uppercase font-bold tracking-wider hover:scale-[101%] rounded-md cursor-pointer text-sm w-1/2 text-center first:mr-4 last:ml-4"
);

const backBtn = clsx(btnStyle + " border-2");

const saveBtn = clsx(btnStyle + " bg-green");
